/**
 * Лист разделов клиента на телефоне.
 *
 * На десктопе разделы стоят в боковом меню, на телефоне его нет —
 * там переходы прячутся за три точки в шапке. Лист занимает экран
 * целиком, поэтому пока он открыт, страница под ним не прокручивается.
 */
export function initClientMenu() {
    const menu = document.querySelector('.client-menu');
    if (!menu) return;
    const open = document.querySelector('.js-client-menu');
    const close = document.querySelector('.js-client-menu-close');

    const setOpen = (isOpen) => {
        menu.hidden = !isOpen;
        document.body.style.overflow = isOpen ? 'hidden' : '';
    };

    if (open) open.addEventListener('click', () => setOpen(true));
    if (close) close.addEventListener('click', () => setOpen(false));
    // Esc закрывает так же, как крестик: лист перекрывает весь экран,
    // и без клавиши из него не выйти с клавиатуры.
    document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape' && !menu.hidden) setOpen(false);
    });
}
